/* eslint-disable no-param-reassign */
// remove underline and capitalize the first letter
export const formatSectionLabel = (str) => {
  str = str.charAt(0).toUpperCase() + str.slice(1);
  return str.replaceAll('_', ' ');
};
